<template>
  <sc-card
    :title="options.layer_id"
    :footer="true"
    controls
    v-if="activeTab !== 'chart'"
    v-loading="!initialRequest"
  >
    <div
      :class="[`sc-basic-widget ${options.type} ${$mq}`]"
      :style="getWidth()"
    >
      <default-list
        v-if="options.type === 'default'"
        :itemList="widgetData.items"
        :colors="colors"
        :icons="icons"
      />
      <simple-list
        v-if="options.type === 'simple'"
        :itemList="widgetData.items"
        :colors="colors"
      />
      <div class="sc-widget__events-control" v-if="options.event_layer">
        <router-link :to="eventEditorLink">
          <el-button class="r-button simple" size="mini" type="primary">
            {{ $t("sc:to-event-editor") }}
          </el-button>
        </router-link>
      </div>
    </div>
    <category-footer
      slot="footer"
      :openModalWindow="openModalWindow"
      :options="options"
      :widgetData="widgetData"
    />
    <card-toggler
      slot="controls"
      v-if="options.hasChart"
      :active="activeTab"
      :toggle-chart="toggleChart"
    />
  </sc-card>
  <sc-card :title="options.layer_id" controls v-else>
    <div
      :class="[`sc-basic-widget ${options.type} sc-chart`]"
      :style="getWidth()"
    >
      <sc-chart
        :chart-data="chartData"
        :colors="chartColors"
        :title="$t(options.layer_id)"
        :type="chartType"
        :changeChartType="changeChartType"
      />
    </div>
    <card-toggler
      slot="controls"
      v-if="options.hasChart"
      :active="activeTab"
      :toggle-chart="toggleChart"
    />
  </sc-card>
</template>

<script>
import scCard from "../../layout/card";
import defaultList from "./renderer/default-list";
import simpleList from "./renderer/simple-list";
import categoryFooter from "./renderer/footer";
import scChart from "../../modules/charts/charts";
import cardToggler from "../card-toggler/card-toggler";

import { dataMapping, getWidgetStyleConfig } from "../../../configs";

export default {
  props: {
    options: {
      type: Object,
      required: true,
      default: () => ({
        layer_id: "",
        type: "default",
        size: "default",
        hasChart: false,
        hasModal: false
      })
    }
  },
  components: {
    scCard,
    defaultList,
    simpleList,
    categoryFooter,
    scChart,
    cardToggler
  },
  data() {
    return {
      chartType: "type-1",
      activeTab: "info"
    };
  },
  computed: {
    widgetData() {
      const data = this.$store.state.situationCenter.layersData.widget[
        this.options.layer_id
      ];

      return data
        ? dataMapping(
            data,
            this.options.event_layer ? "event_stat" : this.options.layer_id,
            "basic_widget"
          )
        : {};
    },
    chartData() {
      return this.widgetData.items.map(e => ({
        value: e.value,
        name: this.$t(e.type)
      }));
    },
    colors() {
      const layerStyle = getWidgetStyleConfig(this.options.layer_id);

      return layerStyle.colors || {};
    },
    icons() {
      const layerStyle = getWidgetStyleConfig(this.options.layer_id);

      return layerStyle.icons || {};
    },
    chartColors() {
      return Object.keys(this.colors).map(e => this.colors[e]);
    },
    eventEditorLink() {
      return this.$store.state.situationCenter.events.event_editor_link;
    },
    initialRequest() {
      return (
        this.$store.state.situationCenter.completedRequests.indexOf(
          this.options.layer_id
        ) !== -1
      );
    }
  },
  methods: {
    getWidth() {
      const styles = {};

      switch (this.options.size) {
        case "small":
          styles["width"] = `264px`;
          break;
        case "large":
          styles["width"] = `580px`;
          break;
        default:
          styles["width"] = `440px`;
          break;
      }

      return styles;
    },
    changeChartType(e) {
      this.chartType = e;
    },
    openModalWindow() {
      if (!this.options.hasModal) return;
      this.$store.commit("SET_SI_CENTER_MODAL_WINDOW", {
        layer_id: this.options.layer_id
      });
      this.$store.commit("OPEN_MODAL_WINDOW", "sc-modal-window");
    },
    toggleChart(e) {
      this.activeTab = e;
    }
  }
};
</script>

<style lang="scss">
.sc-basic-widget {
  height: 100%;
  display: flex;
  &.default {
    margin-bottom: -20px;
    &.sc-chart {
      margin-bottom: 0;
    }
  }
  &.simple {
    max-width: 300px;
  }
  .sc-widget__events-control {
    position: absolute;
    bottom: 8px;
    right: 16px;
  }
}
</style>
